// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page-wrapper {
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--bg-page);
    background-size: cover;
    padding: 20px;
}

.login-card {
    width: 100%;
    max-width: 420px;
    background-color: var(--bg-card);
    padding: 40px;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    display: flex;
    flex-direction: column;
    gap: 24px;
    animation: slideUp 0.5s ease-out;
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

.login-header h1 {
    font-size: 1.75rem;
    font-weight: 800;
    color: var(--text-main);
    text-align: center;
    margin: 0 0 8px 0;
    letter-spacing: -0.02em;
}

.login-subtitle {
    text-align: center;
    color: var(--text-muted);
    font-size: 0.95rem;
    margin: 0;
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-group {
    position: relative;
    width: 100%;
}

.form-group input {
    width: 100%;
    height: 52px;
    padding: 0 16px;
    background-color: var(--bg-input);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-input);
    font-size: 1rem;
    color: var(--text-main);
    transition: var(--transition);
    box-sizing: border-box;
}

.form-group input::placeholder {
    color: #94A3B8;
}

.form-group input:focus {
    outline: none;
    background-color: #fff;
    border-color: var(--brand-primary);
    box-shadow: var(--shadow-input-focus);
}

input[type="email"] {
    text-transform: lowercase;
}

.password-wrapper {
    position: relative;
    width: 100%;
}

.password-wrapper input {
    padding-right: 48px;
}

.toggle-password {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 48px;
    background: none;
    border: none;
    cursor: pointer;
    color: var(--text-muted);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--transition);
}

.toggle-password:hover {
    color: var(--brand-primary);
}

.login-button {
    margin-top: 8px;
    height: 52px;
    width: 100%;
    background-color: var(--brand-accent);
    color: var(--brand-accent-fg);
    border: none;
    border-radius: var(--radius-input);
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: 0 4px 12px rgba(210, 248, 0, 0.25);
}

.login-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(210, 248, 0, 0.4);
    filter: brightness(1.05);
}

.login-button:active {
    transform: scale(0.98);
}

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 12px;
    border-radius: var(--radius-input);
    font-size: 0.9rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.auth-footer {
    text-align: center;
    margin-top: 16px;
    font-size: 0.9rem;
    color: var(--text-muted);
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.auth-link {
    color: var(--brand-primary);
    text-decoration: none;
    font-weight: 600;
    transition: var(--transition);
}

.auth-link:hover {
    text-decoration: underline;
    opacity: 0.8;
}

@media (max-width: 480px) {
    .login-page-wrapper {
        padding: 0;
        background-color: var(--bg-card);
    }

    .login-card {
        box-shadow: none;
        padding: 24px;
        height: 100vh;
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/Login.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,kCAAkC;IAClC,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,qCAAqC;IACrC,6BAA6B;IAC7B,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,gCAAgC;IACpC;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,aAAa;QACb,uBAAuB;IAC3B;AACJ","sourcesContent":[".login-page-wrapper {\n    min-height: 100vh;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--bg-page);\n    background-size: cover;\n    padding: 20px;\n}\n\n.login-card {\n    width: 100%;\n    max-width: 420px;\n    background-color: var(--bg-card);\n    padding: 40px;\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    animation: slideUp 0.5s ease-out;\n}\n\n@keyframes slideUp {\n    from { opacity: 0; transform: translateY(20px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.login-header h1 {\n    font-size: 1.75rem;\n    font-weight: 800;\n    color: var(--text-main);\n    text-align: center;\n    margin: 0 0 8px 0;\n    letter-spacing: -0.02em;\n}\n\n.login-subtitle {\n    text-align: center;\n    color: var(--text-muted);\n    font-size: 0.95rem;\n    margin: 0;\n}\n\n.login-form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.form-group {\n    position: relative;\n    width: 100%;\n}\n\n.form-group input {\n    width: 100%;\n    height: 52px;\n    padding: 0 16px;\n    background-color: var(--bg-input);\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-input);\n    font-size: 1rem;\n    color: var(--text-main);\n    transition: var(--transition);\n    box-sizing: border-box;\n}\n\n.form-group input::placeholder {\n    color: #94A3B8;\n}\n\n.form-group input:focus {\n    outline: none;\n    background-color: #fff;\n    border-color: var(--brand-primary);\n    box-shadow: var(--shadow-input-focus);\n}\n\ninput[type=\"email\"] {\n    text-transform: lowercase;\n}\n\n.password-wrapper {\n    position: relative;\n    width: 100%;\n}\n\n.password-wrapper input {\n    padding-right: 48px;\n}\n\n.toggle-password {\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n    width: 48px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: var(--text-muted);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: var(--transition);\n}\n\n.toggle-password:hover {\n    color: var(--brand-primary);\n}\n\n.login-button {\n    margin-top: 8px;\n    height: 52px;\n    width: 100%;\n    background-color: var(--brand-accent);\n    color: var(--brand-accent-fg);\n    border: none;\n    border-radius: var(--radius-input);\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: var(--transition);\n    box-shadow: 0 4px 12px rgba(210, 248, 0, 0.25);\n}\n\n.login-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(210, 248, 0, 0.4);\n    filter: brightness(1.05);\n}\n\n.login-button:active {\n    transform: scale(0.98);\n}\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 12px;\n    border-radius: var(--radius-input);\n    font-size: 0.9rem;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.auth-footer {\n    text-align: center;\n    margin-top: 16px;\n    font-size: 0.9rem;\n    color: var(--text-muted);\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.auth-link {\n    color: var(--brand-primary);\n    text-decoration: none;\n    font-weight: 600;\n    transition: var(--transition);\n}\n\n.auth-link:hover {\n    text-decoration: underline;\n    opacity: 0.8;\n}\n\n@media (max-width: 480px) {\n    .login-page-wrapper {\n        padding: 0;\n        background-color: var(--bg-card);\n    }\n\n    .login-card {\n        box-shadow: none;\n        padding: 24px;\n        height: 100vh;\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
